export class AssetLien {
  index: number;
  lienId: number;
  acgId: number;
  lienTypeId: number;
  assetId: number;
  accountNumber: string;
  companyName: string;
  contactName: string;
  email: string;
  phone: string;
  fax: string;
  amountOwing: number;
  amountOwingString: string;
  createdDt: Date;
}
